import Row from './Row.js'
import Fragment from './Fragment.js'
import RowHeading from './RowHeading.js'

import './styles.scss'

export default {
    fragment: Fragment,
    row: Row,
    rowHeading: RowHeading,
}
